import { createSlice } from "@reduxjs/toolkit";
import { registerDealerExtraReducers } from "./extraReducers";
import { initialState } from "./initialState";
import { dealerReducers } from "./reducers";

export const dealersSlice = createSlice({
  name: "dealer",
  initialState,
  reducers: dealerReducers,
  extraReducers: registerDealerExtraReducers,
});

export const {
  searchDealerUser,
  sortDealerUserList,
  setCurrentBranch,
  searchDealerBranch,
  setLoading,
  setBranchColumnsToHide,
  sortDealerBranchesList,
  setSortRules,
  setSelectedFilials,
  sortDealerFilials,
  setFilialSortRules,
  searchDealers,
  setOnlyExporters,
  setOnlySelfWorkers,
  setMyDealers,
  setCurrentDealer,
  setSelectedDealerIds,
  setIsDatePickerActive,
  setDealerSort,
  resetDealerFilters,
} = dealersSlice.actions;
